import Header from "../User/Navbar";
import Hero from "./Subsections/Hero";
import { FeaturedStories } from "./Subsections/FeaturedStories";
import { TopStories } from "./Subsections/TopServices";
import { WorldNews } from "./Subsections/WorldNews";
import { PopularPosts } from "./Subsections/PopularPosts";
import { SocialStats } from "./Subsections/SocialStats";
import { Categories } from "./Subsections/Categories";
import { SubscribeCard } from "./Subsections/SubscribeCard";
import Footer from "../LandingpPage/SubComponent/Footer";
import Loader from "../Loader/Loader";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";

export default function Page() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllBlogs = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://rohan-tax-services.onrender.com/api/auth/fetchblog",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      if (response.ok) {
        const reformmed = result.reverse();
        setData(reformmed);
        sessionStorage.setItem(
          "RohanTaxServicesMain",
          JSON.stringify(reformmed)
        );
      } else {
        toast.error(result.msg || "Failed to fetch blogs");
      }
    } catch (error) {
      toast.error("Error fetching blogs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("RohanTaxServicesMain");
    if (storedData) {
      setData(JSON.parse(storedData));
    } else {
      fetchAllBlogs();
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  const mainpost = data[0];
  const filteredBlogs = data.slice(1, 4);

  const itpost = data
    .filter((post) => post.category === "Income Tax")
    .slice(0, 3);
  const gstpost = data
    .filter((post) => post.category === "GST (Goods and Services Tax)")
    .slice(0, 3);
  const ngpost = data
    .filter((post) => post.category === "TaxUpdates NG")
    .slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <div className="mb-5">
          <Hero />
        </div>
        {mainpost ? (
          <FeaturedStories mainpost={mainpost} filteredBlogs={filteredBlogs} />
        ) : (
          <div className="text-center">No featured stories available</div>
        )}
        <div className="container mx-auto px-4 py-8">
          <div className="grid lg:grid-cols-[1fr_300px] gap-8">
            <div className="space-y-12">
              <TopStories
                itpost={itpost}
                gstpost={gstpost}
                ngpost={ngpost}
                data={data}
              />
            </div>
            <aside className="space-y-8">
              <SocialStats />
              <Categories data={data} />
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
